import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { version } from 'src/environments/version';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    console.log('Loading translation for language:', lang);

    // eslint-disable-next-line no-restricted-globals
    return this.http.get<Translation>(`/assets/i18n/${lang}.json?${version.hash !== 'undefined' ? version.hash : new Date().getTime()}`);
  }
}
